import { render } from "./InformationDialog.vue?vue&type=template&id=9cf67e80&scoped=true"
import script from "./InformationDialog.vue?vue&type=script&lang=js"
export * from "./InformationDialog.vue?vue&type=script&lang=js"

import "./InformationDialog.vue?vue&type=style&index=0&id=9cf67e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf67e80"]])

export default __exports__